import { render } from "./NavsPage.vue?vue&type=template&id=4417f067&ts=true"
import script from "./NavsPage.vue?vue&type=script&lang=ts"
export * from "./NavsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__